import React, { Component } from 'react'

export default class Tooltip extends Component {
    constructor(props){
        super(props)
    }

    render() {
        //this.props.children: String, HtmlElement
        //o nome da classe deve ser custom-tooltip para não conflitar com a classe tooltip do Bootstrap (que não funcionou como deveria)
        return (
            <div className="custom-tooltip">
                {this.props.position && this.props.position  === "bottom" &&
                    this.props.children
                }
                {!this.props.position &&
                    this.props.children
                }
                <span className={`tooltiptext`}>{this.props.tooltipText}</span>
                {this.props.position && this.props.position === "top" &&
                    this.props.children
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/Tooltip.js